import { Card } from "./Card";

export class OrganisationCard extends Card {

    stripeAccountId(){
        return null
    }

    constructor(id=null, addParams=null) {
        super();
        this.entityClass = 'organisation_card';
        this.urlRoot = '/organisation/cards';
        this.sectionRootUrl = '/organisation';
        this.id = id;
        this.addParams=addParams
    }

}
